// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f5039f7c","125":"e37acc29","179":"e6054433","228":"9a8d47dc","272":"8ec62dfe","352":"218028a2","549":"754ac649","666":"b2c655b9","816":"86b2c681","930":"5b398b50","996":"4601ef27"}[chunkId] + ".chunk.js";
};